/** Lowercase, ё→е, punctuation and whitespace collapsed to single spaces. */
export function normalizeText(text: string): string {
  return text
    .toLowerCase()
    .replace(/ё/g, 'е')
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim();
}

/**
 * True when `phrase` occurs in `text` as whole words after normalization,
 * so "пала" does not match inside "проспала".
 */
export function containsPhrase(text: string, phrase: string): boolean {
  const needle = normalizeText(phrase);
  if (needle.length === 0) return false;
  return ` ${normalizeText(text)} `.includes(` ${needle} `);
}
